import React from "react";
import cx from "classnames";
import classes from "./FormStartBox.module.scss";
import { NavLink } from "react-router-dom";
import dompurify from "dompurify";

const formStartBox = (props) => {
  let formStartContent;
  let formStartContentOutput;
  const sanitizer = dompurify.sanitize;

  const activeLink =
    props.buttonName === "Select" ||
    props.buttonName === "Chat with a Nationals Representative";
  formStartContent = (
    <div
      className={cx(
        classes._FormStartBox,
        props.featured ? classes.featured : ""
      )}
    >
      <img
        src={props.icon}
        alt={props.title + " Icon"}
        style={props.iconStyle}
      />
      <div
        className={classes.title}
        dangerouslySetInnerHTML={{ __html: sanitizer(props.title) }}
      />
      {props.message && (
        <div
          className={classes.message}
          dangerouslySetInnerHTML={{ __html: sanitizer(props.message) }}
        />
      )}
      <div className={classes.description}>{props.description}</div>
      <div
        className={cx(classes.button, !activeLink ? classes.disable_btn : null)}
      >
        {props.buttonName}
      </div>
    </div>
  );

  formStartContentOutput = props.externalLink ? (
    activeLink ? (
      <>
        {props.externalLink !== "chat" ? (
          <a
            href={props.buttonLink}
            className={classes.FormStartBox}
            onClick={props.updateSelectedChoices}
            target="_blank"
            rel="noopener noreferrer"
          >
            {formStartContent}
          </a>
        ) : (
          <div
            className={classes.FormStartBox}
            onClick={() => {
              window.chatBtn();
              if (window.adobeAnalytics && window.adobeAnalytics.tl) {
                window.adobeAnalytics.tl(
                  true,
                  "o",
                  "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                  {
                    prop12: "navigation",
                    prop13:
                      "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                    prop14: `chat with a representative click`,
                    evar140: "Chat With A Nationals Representative",
                  }
                );
              }
            }}
          >
            {formStartContent}
          </div>
        )}
      </>
    ) : (
      <div className={classes.FormStartBox}>{formStartContent}</div>
    )
  ) : activeLink ? (
    <NavLink
      to={props.buttonLink}
      className={classes.FormStartBox}
      onClick={props.updateSelectedChoices}
    >
      {formStartContent}
    </NavLink>
  ) : (
    <div className={classes.FormStartBox}>{formStartContent}</div>
  );

  return formStartContentOutput;
};

export default formStartBox;
